import { render, staticRenderFns } from "./PaySetting.vue?vue&type=template&id=674c8f18&scoped=true"
import script from "./PaySetting.vue?vue&type=script&lang=js"
export * from "./PaySetting.vue?vue&type=script&lang=js"
import style0 from "./PaySetting.vue?vue&type=style&index=0&id=674c8f18&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674c8f18",
  null
  
)

export default component.exports